import React, {useState} from 'react'

// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Button,
} from "reactstrap";

import ModuleNavbar from 'components/Navbars/ModuleNavbar';
import { useLocation } from 'react-router-dom';

const DataImportPage = (props) => {
    const {children} = props
    const location = useLocation().pathname.split('/').pop()
    const [func, setFunc] = useState(false);
    const displayFunction = (e) => {
        setFunc(!func);
    }

    return (
    <div className="content">
        <ModuleNavbar title='Wprowadzanie danych' color='#1C748F' icon='nc-icon nc-single-copy-04' func={displayFunction} page={8}/>
     {!func && <>
      {children}
      </>}
        {func && <>
                <Card>
                    <CardHeader>
                        <CardTitle tag="h5">
                            Drogi Użytkowniku,
                        </CardTitle>
                    </CardHeader>
                    <CardBody style={{textAlign: 'justify', lineHeight: '2', fontSize: '14px'}}>
                    {location==='import_five_four' &&<>
                        W&nbsp;panelu <span className='text-import'>„Import słowników”</span> zaimportujesz strukturę kont zespołu 4&nbsp;i&nbsp;5, 
                        występującą w&nbsp;Twoim podmiocie.
                        <br/>
                        W tym celu należy:
                        <ul>
                            <li>
                                za&nbsp;pomocą przycisku 
                                <Button size='sm' className="btn-round my-0 mx-2" color="import" outline type="button">
                                    <i className="fas fa-download mr-2"/> Pobierz szablon pliku
                                </Button> 
                                pobrać wzorcowy arkusz MS Excel, aby wprowadzić listę wyodrębnionych Ośrodków Powstawania Kosztów oraz kont rodzajowych.
                            </li>
                            <li>
                                pobrany plik możesz zapisać na&nbsp;dysku własnego komputera i&nbsp;uzupełniać etapowo zapisując wszystkie wprowadzone dane.
                            </li>
                        </ul>
                        W&nbsp;szablonie pliku znajdują się dwa arkusze:
                        <ol>
                            <li>konta zespołu 5</li>
                            <li>konta zespołu 4.</li>
                        </ol>
                        W arkuszu Konta zespołu 5 należy:
                        <ul>
                            <li>wykazać wszystkie Ośrodki Powstawania Kosztów występujące w&nbsp;Twoim podmiocie,</li>
                            <li>arkusz należy uzupełnić zgodnie ze&nbsp;wzorem podając symbol i&nbsp;nazwę kont zespołu 5,</li>
                            <li>w&nbsp;przypadku, gdy przyjęta w&nbsp;Twoim podmiocie symbolika kont zespołu 5 różni się od&nbsp;podanej 
                                w&nbsp;rozporządzeniu uzupełnij dodatkowo kolumny C, D i&nbsp;E wg&nbsp;wzoru.</li>
                        </ul>
                        W&nbsp;arkuszu Konta zespołu 4 należy:
                        <ul>
                            <li>wykazać wszystkie konta rodzajowe występujące w&nbsp;Twoim systemie finansowo-księgowym,</li>
                            <li>arkusz należy uzupełnić zgodnie ze&nbsp;wzorem podając symbol i&nbsp;nazwę konta zespołu 4, 
                                uwzględniając wprowadzone dodatkowo kolejne poziomy analityki.</li>
                        </ul>
                        Po wprowadzeniu danych sprawdź ich poprawność i&nbsp;prześlij plik.
                        <br/>
                        Aby przesłać plik z&nbsp;danymi należy, za&nbsp;pomocą przycisku 
                        <Button size='sm' className="btn-round my-0 mx-2" color="import" type="button">
                            Wybierz
                        </Button>
                        odszukaj uzupełniony szablon pliku i&nbsp;kliknij w przycisk 
                        <Button size='sm' className="btn-round m-0 mx-2" color="import" outline type="button">
                            <i className="fas fa-upload mr-2"/> Prześlij plik
                        </Button>
                        , w&nbsp;celu&nbsp;wgrania go&nbsp;do&nbsp;aplikacji. Plik ze&nbsp;zdefiniowanymi kontami zespołu 4 i&nbsp;5 pojawi się na&nbsp;liście przesłanych plików.
                        <br />
                        Aby go&nbsp;zaimportować (zatwierdzić w&nbsp;aplikacji) należy kliknąć w&nbsp;przycisk 
                        <Button className="btn-link my-0" color="info" size="sm" type="button" >
                            <i className="fas fa-upload"></i>
                        </Button>
                        importuj dane z&nbsp;pliku.
                        <br />
                        Po&nbsp;prawidłowym zaimportowaniu danych pojawi się
                        {/* <Button className="btn-link my-0" color="success" size="sm" type="button" > */}
                            <i className="fas fa-check mx-2"></i>
                        {/* </Button> */}
                        zaimportowano słownik. Wybierając opcję 
                        <Button className="btn-link my-0" color="success" size="sm" type="button" >
                            <i className="fas fa-download"></i>
                        </Button>
                        pobierz plik, masz możliwość pobrania zaimportowanego pliku.
                        
                    </>}
                    {location==='opk_edit' &&<>
                        W&nbsp;panelu <span className='text-import'>„Edycja słowników</span> masz możliwość:
                        <ul>
                            <li>edytowania zaimportowanych słowników kont zespołu 4 i&nbsp;5</li>
                            <li>wprowadzenia pojedynczych dodatkowych kont zespołu 4 i&nbsp;5 - nie&nbsp;musisz powtórnie importować w&nbsp;całości słowników.</li>
                        </ul>
                        Aby dodać Ośrodek Powstawania Kosztów:
                        <ul>
                            <li>
                                wybierz zakładkę „Edycja kont zespołu 5” i&nbsp;uzupełnij kolejno pola:<br />
                                - kod syntetyczny,<br />
                                - kod resortowy,<br />
                                - kod własny,<br />
                                - typ OPK,<br />
                                - numer OPK,<br />
                                - nazwa OPK,<br />
                                - a&nbsp;także określ rodzaj kosztu (stałe/zmienne)<br />
                                - i&nbsp;kliknij w przycisk 
                                <Button className="btn btn-round my-0 mx-2" outline size='sm' color="import" type="button" >
                                    <i className='nc-icon nc-simple-add'></i>
                                </Button>
                                dodaj.
                            </li>
                        </ul>
                        Dodany OPK pojawi się na&nbsp;liście wyodrębnionych OPK. W&nbsp;sytuacji, gdy chcesz dokonać zmian w&nbsp;dodanych Ośrodkach Powstawania 
                        Kosztów możesz edytować pole z&nbsp;nazwą OPK i&nbsp;rodzajem kosztów - po&nbsp;wprowadzeniu zmian należy je&nbsp;zapisać za&nbsp;pomocą przycisku 
                        <Button className="btn-link my-0" color="import" type="button" >
                            <i className="far fa-save fa-2x"></i>
                        </Button>.
                        <br />
                        W&nbsp;przypadku założenia dodatkowych kont rodzajowych zespołu 4 należy:
                        <ul>
                            <li>
                                wybrać zakładkę „Edycja kont rodzajowych zespołu 4” i&nbsp;uzupełnić kolejno pola:<br />
                                - symbol konta,<br />
                                - nazwa analityczna,<br />
                                - numer własny&nbsp;1,<br />
                                - nazwa własna&nbsp;1,<br />
                                - numer własny&nbsp;2,<br />
                                - nazwa własna&nbsp;2<br />
                                - a&nbsp;także rodzaj kosztu<br />
                                - i&nbsp;kliknąć w&nbsp;przycisk dodaj.
                            </li>
                        </ul>
                        Dodane konto rodzajowe pojawi się na&nbsp;liście kont rodzajowych zespołu 4.
                        <br/>
                        W&nbsp;sytuacji, gdy chcesz dokonać zmian w&nbsp;dodanych kontach rodzajowych możesz edytować pole z&nbsp;numerem własnym, 
                        nazwą własną i&nbsp;rodzajem kosztów - po&nbsp;wprowadzeniu zmian należy je&nbsp;zapisać za&nbsp;pomocą przycisku
                        <Button className="btn-link my-0" color="import" type="button" >
                            <i className="far fa-save fa-2x"></i>
                        </Button>.
                    </>}
                    {location==='data_import' &&<>
                        W&nbsp;panelu <span className='text-import'>„Import danych”</span> w&nbsp;prosty sposób zaimportujesz dane niezbędne do&nbsp;prawidłowego 
                        przeprowadzenia procesu rozliczenia kosztów zgodnie z&nbsp;zapisami rozporządzenia&nbsp;MZ z&nbsp;dnia 26&nbsp;października 2020&nbsp;roku 
                        w&nbsp;sprawie zaleceń standardu rachunku kosztów u&nbsp;świadczeniodawców.
                        <br/>
                        W tym celu należy:
                        <ul>
                            <li>
                                za&nbsp;pomocą przycisku <Button size='sm' className="btn-round my-0 mx-2" color="import" outline type="button">
                                    <i className="fas fa-download mr-2"/> Pobierz szablon pliku
                                </Button> pobrać wzorcowy arkusz MS&nbsp;Excel, aby wprowadzić dane niezbędne do&nbsp;rozliczenia kosztów,
                            </li>
                            <li>pobrany plik możesz zapisać na&nbsp;dysku własnego komputera i&nbsp;uzupełniać etapowo zapisując wszystkie wprowadzone dane.</li>
                        </ul>
                        W pliku znajdują się sześć arkuszy:
                        <ol>
                            <li>Koszty bezpośrednie&nbsp;FK,</li>
                            <li>OPK pomocnicze klucze podziałowe,</li>
                            <li>OPK proceduralne i&nbsp;pomocnicze statystyka,</li>
                            <li>Wycena procedur i&nbsp;usług,</li>
                            <li>OPK przychody,</li>
                            <li>Dane statystyczne - świadczenia.</li>
                        </ol>
                        W arkuszu Koszty bezpośrednie&nbsp;FK należy:
                        <ul>
                            <li>wykazać rok i&nbsp;miesiąc, którego dotyczy rozliczenie,</li>
                            <li>numery kont zespołu&nbsp;5 i&nbsp;numery kont zespołu&nbsp;4 oraz wartość kosztu (suma wszystkich kosztów w&nbsp;systemie finansowym 
                                podmiotu) – dane&nbsp;te&nbsp;wygenerujesz z&nbsp;systemu&nbsp;FK.</li>
                        </ul>
                        Arkusz OPK pomocnicze klucze podziałowe, gdzie należy wskazać:
                        <ul>
                            <li>rok i&nbsp;miesiąc, którego dotyczy rozliczenie,</li>
                            <li>symbol konta OPK pomocniczego,</li>
                            <li>nazwę klucza podziałowego,</li>
                            <li>symbol OPK, na&nbsp;który alokowany zostanie koszt,</li>
                            <li>liczbę jednostek rozliczeniowych przyjętą w&nbsp;kluczu (jednostką rozliczeniową może być np.&nbsp;liczba usług lub wartość procentowa).</li>
                        </ul>
                        Pamiętaj! Należy ująć wszystkie ośrodki działalności pomocniczej, zarówno medyczne, jak i&nbsp;niemedyczne - jest to&nbsp;niezbędne 
                        dla&nbsp;prawidłowego przeprowadzenia II&nbsp;etapu kalkulacji kosztu wytworzenia OPK.
                        <br/><br/>
                        Arkusz OPK proceduralne i&nbsp;pomocnicze statystyka, gdzie należy wskazać:
                        <ul>
                            <li>rok i&nbsp;miesiąc, którego dotyczy rozliczenie,</li>
                            <li>symbol OPK proceduralnego/pomocniczego,</li>
                            <li>kod procedury według klasyfikacji ICD-9 i/lub&nbsp;przyjęty własny,</li>
                            <li>liczbę wykonanych procedur/usług w&nbsp;połączeniu z&nbsp;jednostką zlecającą.</li>
                        </ul>
                        Pamiętaj! Należy ująć wszystkie ośrodki proceduralne oraz OPK działalności pomocniczej medycznej i&nbsp;niemedycznej, dla&nbsp;których 
                        przyjąłeś rozliczenie w&nbsp;oparciu o&nbsp;wyliczony jednostkowy koszt normatywny z&nbsp;uwzględnieniem wszystkich wykonywanych 
                        w&nbsp;nich procedur/usług - jest to&nbsp;niezbędne dla prawidłowego przeprowadzenia II i&nbsp;III&nbsp;etapu kalkulacji kosztu wytworzenia&nbsp;OPK.
                        <br/><br/>
                        Arkusz Wycena procedur i&nbsp;usług, gdzie należy wprowadzić:
                        <ul>
                            <li>symbol OPK proceduralnego/pomocniczego,</li>
                            <li>kod procedury według klasyfikacji ICD-9 i/lub przyjęty własny,</li>
                            <li>nazwę procedury/usługi,</li>
                            <li>jednostkowy koszt normatywny.</li>
                        </ul>
                        Jeżeli rozliczasz koszty pośrednie metodą opartą na&nbsp;kosztach typowo zużytych zasobów – proporcjonalnie do&nbsp;czasu trwania procedury 
                        uzupełnij kolumnę „średni standardowy czas trwania procedury (minuty/godziny)”.<br/>
                        Pamiętaj! Należy ująć wszystkie ośrodki proceduralne oraz OPK działalności pomocniczej medycznej i&nbsp;niemedycznej, dla&nbsp;których 
                        przyjąłeś rozliczenie w oparciu o&nbsp;wyliczony jednostkowy koszt normatywny z&nbsp;uwzględnieniem wszystkich wykonywanych w&nbsp;nich 
                        procedur/usług - jest to&nbsp;niezbędne dla prawidłowego przeprowadzenia II i&nbsp;III&nbsp;etapu kalkulacji kosztu wytworzenia OPK.<br/>
                        Masz możliwość kalkulacji jednostkowego kosztu normatywnego w&nbsp;module wycena procedur medycznych poprzez automatyczne zdefiniowanie 
                        zasobów w&nbsp;aplikacji.
                        <br/><br/>
                        Arkusz OPK Przychody, gdzie należy wskazać:
                        <ul>
                            <li>rok i&nbsp;miesiąc, którego dotyczą przychody,</li>
                            <li>wartość kontraktu z&nbsp;NFZ (miesięcznie i&nbsp;rocznie),</li>
                            <li>wartość miesięcznego wykonania kontraktu,</li>
                            <li>wartość przychodów OPK w&nbsp;miesiącu rozliczeniowym, dzięki czemu uzyskasz informację o&nbsp;wyniku finansowym 
                                na&nbsp;poszczególnych ośrodkach i&nbsp;procencie zrealizowanego kontraktu.</li>
                        </ul>
                        Arkusz Dane statystyczne - świadczenia, gdzie wprowadzisz:
                        <ul>
                            <li>liczbę porad,</li>
                            <li>liczbę hospitalizowanych,</li>
                            <li>wykonanych osobodni,</li>
                            <li>liczbę łóżek w&nbsp;poszczególnych OPK, dzięki temu w&nbsp;module raportowym uzyskasz informację o&nbsp;danych finansowych 
                                i&nbsp;statystycznych dla każdego OPK. Po wprowadzeniu niezbędnych danych sprawdź ich poprawność i&nbsp;prześlij plik.</li>
                        </ul>
                        Aby przesłać plik z&nbsp;danymi, za&nbsp;pomocą przycisku 
                        <Button size='sm' className="btn-round my-0 mx-2" color="import" type="button">
                            Wybierz
                        </Button>
                        odszukaj uzupełniony szablon pliku i&nbsp;kliknij w&nbsp;przycisk 
                        <Button size='sm' className="btn-round m-0 mx-2" color="import" outline type="button">
                            <i className="fas fa-upload mr-2"/> Prześlij plik
                        </Button>
                        w&nbsp;celu wgrania go&nbsp;do&nbsp;aplikacji.
                        <br/>
                        Plik z&nbsp;wprowadzonymi danymi pojawi się na&nbsp;liście przesłanych plików. Następnie kliknij w&nbsp;przycisk 
                        <Button className="btn-link my-0" color="danger" size="sm" type="button" >
                            <i className="fas fa-times"></i>
                        </Button>
                        w&nbsp;celu sprawdzenia kont zespołu 4 i&nbsp;5. Jeżeli weryfikacja przebiegła prawidłowo, pojawi się 
                        <Button className="btn-link my-0" color="success" size="sm" type="button" >
                            <i className="fas fa-check"></i>
                        </Button>. Aby plik z&nbsp;danymi zaimportować (zatwierdzić w aplikacji) należy kliknąć w&nbsp;przycisk
                        <Button className="btn-link my-0" color="info" size="sm" type="button" >
                            <i className="fas fa-upload"></i>
                        </Button>
                        importuj dane z&nbsp;pliku. Po&nbsp;zaimportowaniu pojawi się komunikat „Zakończono import” 
                        i&nbsp;arkusz z&nbsp;danymi będzie widoczny na&nbsp;liście przesłanych plików w&nbsp;Panelu „Rozliczenie kosztów”.
                        <br/>
                        Wybierając opcję <Button className="btn-link my-0" color="success" size="sm" type="button" >
                            <i className="fas fa-download"></i>
                        </Button>pobierz plik, masz możliwość pobrania zaimportowanego pliku lub&nbsp;w&nbsp;przypadku błędnych danych, 
                        usunięcia ich.
                    </>}
                    {location==='calculate_data' &&<>
                        W&nbsp;panelu <span className='text-import'>„Rozliczenie kosztów”</span> rozliczysz koszty za&nbsp;dany miesiąc na&nbsp;podstawie 
                        zaimportowanego wcześniej arkusza z&nbsp;danymi.
                        <br/>
                        W&nbsp;tym celu należy:
                        <ul>
                            <li>kliknąć w&nbsp;przycisk <Button className="btn-link my-0" color="info" size="sm" type="button" >
                                <i className="fas fa-upload"></i>
                            </Button>, po&nbsp;zakończeniu otrzymasz informację zwrotną o&nbsp;zakończeniu procesu.</li>
                            <li>sprawdź poprawność danych po&nbsp;rozliczeniu, w&nbsp;tym celu w&nbsp;module Raporty wybierz „Raport po&nbsp;podziale kosztów”</li>
                            <li>zweryfikuj czy&nbsp;wartość kosztów przed podziałem i&nbsp;po&nbsp;podziale jest zgodna (suma kosztów bezpośrednich musi być równa 
                                sumie wartości kosztów po&nbsp;przekazaniu) oraz czy wszystkie OPK pomocnicze i&nbsp;proceduralne zostały rozliczone prawidłowo.</li>
                        </ul>
                        Po sprawdzeniu rozliczenia kosztów możesz przystąpić do&nbsp;ich&nbsp;analizy w&nbsp;module raportowym lub z&nbsp;poziomu pulpitu zarządczego.
                    </>}
                    <br />
                    <Button className="btn-round" outline color="import" onClick={()=>{
                            window.focus();
                            window.scrollTo(0, 0);
                            displayFunction('main');
                        }} style={{float:"right",margin:"0px !important"}}> Powrót </Button>
                    </CardBody>
                </Card>
            </>}
    </div>
    )
}

export default DataImportPage
